import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject, input, signal, viewChild } from '@angular/core';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import { HlmPaginationImports } from '../../../../ui/pagination/src';
import { toast } from 'ngx-sonner';
// import { Store } from '@ngrx/store';
import { EMPTY, Observable, Subscription, catchError, filter, of, switchMap, tap } from 'rxjs';
import { User, UserRole } from 'src/app/core/models/users';
import { UsersService } from 'src/app/core/services/users.service';
// import { updateTextSearchFilter } from 'src/app/core/store/management/actions/user-filters.actions';
// import { updateUserCurrentPage } from 'src/app/core/store/management/actions/user.actions';
// import { selectUserCurrentPage, selectUserFilterFilters, selectUserFilters } from 'src/app/core/store/management/reducers';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideFilter, lucidePencil, lucideMail, lucideCopy } from '@ng-icons/lucide';
import { HlmIcon } from '../../../../ui/icon/src';
import { HlmButton } from '../../../../ui/button/src';
import { HlmTooltipImports } from '../../../../ui/tooltip/src';
import { HlmTableImports } from 'src/app/ui/table/src';
import { WhoAmIService } from 'src/app/auth/services/whoami.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { TextSearchFilterComponent } from '../../coll-filters/search-filter/text-search-filter.component';
import { PageFiltersAndCtaComponent } from '../../page-filters-and-cta/page-filters-and-cta.component';
import { EditUserDetailsDialogComponent } from '../edit-user-details-dialog/edit-user-details-dialog.component';
import { InviteUserDialogComponent } from './user-invite-dialog.component';
import { UserPropsFilterDialogComponent } from './user-props-filter-dialog.component';
import { formatId } from '@shared/utils/restheart-id.utils';

@Component({
  selector: 'app-users-management',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  imports: [
    PageFiltersAndCtaComponent,
    TextSearchFilterComponent,
    HlmButton,
    NgIcon,
    HlmIcon,
    ...HlmTooltipImports,
    CdkCopyToClipboard,
    ...HlmPaginationImports,
    AsyncPipe,
    TitleCasePipe,
    ...HlmTableImports,
  ],
  providers: [provideIcons({ lucideFilter, lucidePencil, lucideMail, lucideCopy })],
})
export class UsersManagementComponent implements OnInit, OnDestroy {
  private userSvc = inject(UsersService);
  inviteFormDialog = inject(HlmDialogService);
  dialog = inject(HlmDialogService);
  // private store = inject(Store);
  private whoami = inject(WhoAmIService);

  readonly isTenantFilterEnabled = input<boolean>(true);

  tableCols = ['_id', 'tenant', 'name', 'surname', 'roles', 'phone', 'action'];

  users = signal<User[]>([]);

  itemsPerPage = signal<number>(10);

  currentPage = signal<number>(1);

  canResendEmail = true;

  userCollectionSize!: number;

  isPaginatorDisabled = true;

  searchProps = ['_id', 'profile.surname', 'profile.name'];

  filterQuery = signal('');

  sub = new Subscription();

  filterDialogDirty: boolean = false;

  currentUser = this.whoami.user;

  ngOnInit(): void {
    // const queryParamsSub = this.resolveFiltersToQueryString().subscribe();
    // this.sub.add(queryParamsSub);
    // this.userList$ = combineLatest([this.filterQuery$, this.store.select(selectUserCurrentPage)]).pipe(
    //   switchMap(([filters, currentPage]) =>
    //     forkJoin([
    //       this.userSvc.getPage(currentPage.pageIndex + 1, this.pageSize, filters),
    //       this.userSvc.getUserCollectionSize(filters),
    //       of(currentPage),
    //     ])
    //   ),
    //   tap(([users, collectionSize, { pageIndex }]) => {
    //     this.users$.next(users);
    //     this.userCollectionSize = collectionSize;
    //     const paginator = this.paginator();
    //     paginator.pageIndex = pageIndex;
    //     paginator.length = collectionSize;
    //     paginator.pageSize = this.pageSize;
    //     this.isPaginatorDisabled = false;
    //   }),
    //   switchMap(([users]) => of(users))
    // );
    // const s = this.store
    //   .select(selectUserFilterFilters)
    //   .pipe(
    //     take(1),
    //     tap(f => {
    //       this.filterDialogDirty = !f.status.enabled || f.status.disabled || (f.tenants !== null && f.tenants?.length > 0) || (f.roles !== null && f.roles?.length > 0);
    //     })
    //   )
    //   .subscribe();
    //   this.sub.add(s);
  }

  onFilterQueryChange(query: string) {
    this.filterQuery.set(query);
  }

  onSearchChange(value: string) {
    //this.store.dispatch(updateUserCurrentPage({pageIndex: 0, pageSize: 10, length: 0}));
    // this.store.dispatch(updateTextSearchFilter({ value }));
  }

  resendEmail(userId: string) {
    this.userSvc.sendEmail(userId).subscribe({
      next: () => {
        toast.success('Email sent');
      },
      error: err => console.error('[Management/User] Failed to sent email', err),
    });
  }

  resetOrActivationLink(user: User) {
    const baseAppUrl = typeof window !== 'undefined' ? window.location.origin : '';

    const roles = user.roles;
    const email = user._id;
    const otp = user.pwdAuth?.code;
    const cg = user.consents ? 'true' : 'false';

    return roles.includes(UserRole.LOCKED_USER)
      ? `${baseAppUrl}/auth/activate?email=${email}&token=${otp}&cg=${cg}`
      : `${baseAppUrl}/auth/reset-password?email=${email}&token=${otp}`;
  }

  openConfirmationDialog(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmActionComponent, {
      context: {}
    });
    return dialogRef.closed$;
  }

  joinRoles(roles: UserRole[]) {
    const roleMap: { [key: string]: string } = {
      'locked-user': 'pending…',
      // Add other role mappings as needed
    };

    const roleNames = roles.map(role => {
      if (role.match('locked-user')) {
        return roleMap['locked-user'];
      } else {
        // Return the role as-is or map it if needed
        return roleMap[role] || role;
      }
    });

    return of(roleNames.join(','));
  }

  isLockedUser(roles: UserRole[]): boolean {
    return roles.some(role => role.match('locked-user'));
  }

  inviteUser(): void {
    const dialogRef = this.inviteFormDialog.open(InviteUserDialogComponent, {
      context: {}
    });

    const sub = dialogRef
      .closed$
      .pipe(
        filter(data => !!data),
        switchMap(data => this.userSvc.inviteUser(data)),
        switchMap(() => of(this.filterQuery())),
        switchMap(filters =>
          this.userSvc.getPage(1, this.itemsPerPage(), filters).pipe(
            tap((users: User[]) => {
              // this.store.dispatch(updateUserCurrentPage({ pageIndex: 0, pageSize: 10, length: 0 }));
              this.users.set(users);
              this.currentPage.set(1);
            })
          )
        ),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 409) {
            toast.error('User already exists');
            console.error(err);
          } else {
            toast.error('Could not invite the user');
            console.error('[Management/Users] Error while trying to invite user', err);
          }

          return EMPTY;
        })
      )
      .subscribe();

    this.sub.add(sub);
  }

  // After successfully editing a user, reload the current page
  openEditDialog(user: User) {
    this.dialog
      .open(EditUserDetailsDialogComponent, {
        context: { user },
      })
      .closed$
      .pipe(
        filter((data): data is { action: string; payload?: any } => !!data),
        switchMap(data => {
          if (data.action === 'delete') {
            return of(null);
          } else {
            return this.userSvc.update(user._id, data.payload);
          }
        }),
        switchMap(() => this.userSvc.getPage(1, this.itemsPerPage(), this.filterQuery())),
        tap((users: User[]) => this.users.set(users))
      )
      .subscribe({
        next: () => toast.success('User updated'),
        error: () => toast.error('Could not update the user'),
      });
  }

  openUserPropsFilterDialog() {
    const dialogRef = this.dialog.open(UserPropsFilterDialogComponent, {
      context: {}
    });
    // TODO: Spartan dialog doesn't expose componentInstance - need to refactor this communication
    // const s = dialogRef.componentInstance.dirty.subscribe((d: any) => (this.filterDialogDirty = d));
    // this.sub.add(s);
  }

  resolveFiltersToQueryString() {
    // return this.store.select(selectUserFilters).pipe(
    //   switchMap(({ filters, search }) => {
    //     const { roles, status, tenants } = filters;
    //     const { enabled, disabled } = status;
    //     let query = [];
    //     if (search?.value?.length) {
    //       const ref = escapeAndEncodeRegexFilterValue(search.value);
    //       query.push(
    //         `filter={"$or":[{"_id":{"$regex":"${ref}", "$options":"i"}}, {"profile.name":{"$regex":"${ref}", "$options":"i"}},{"profile.surname":{"$regex":"${escapeAndEncodeRegexFilterValue(search.value)}", "$options":"i"}} ]}`
    //       );
    //     }
    //     if (enabled !== disabled) {
    //       query.push(`filter={"enabled": ${enabled === true}}`);
    //     }
    //     if (roles?.length) {
    //       const vals = roles.map(role => `"${role}"`).join(',');
    //       query.push(`filter={"roles":{"$in": [${vals}]}}`);
    //     }
    //     if (tenants?.length) {
    //       const vals = tenants.map(tenant => `"${escapeFilterValueNoRegex(tenant)}"`).join(',');
    //       query.push(`filter={"tenants":{"$in":[${vals}]}}`);
    //     }
    //     return of(query.join('&'));
    //   })
    //   // tap(query => this.filterQuery$.next(query))
    // );
  }

  formatId(id: any): string {
    return formatId(id);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
